<script setup lang="ts">
import { computed } from 'vue'
import { SpinnerSize } from 'frontcore/views/loaders/spinner/types'

interface Props {
  size?: SpinnerSize
  colorCssVar?: string
}

const props = withDefaults(
  defineProps<Props>(), {
    size: SpinnerSize.DEFAULT,
    colorCssVar: 'core-primary-60',
  }
)

const sizeClasses = {
  [SpinnerSize.SMALL]: 'spinner-small-size tw-w-6 tw-h-6',
  [SpinnerSize.DEFAULT]: 'spinner-default-size tw-w-10 tw-h-10',
}

const sizeClass = computed(() => {
  return sizeClasses[props.size]
})

const colorStyle = computed<Record<string, string>>(() => {
  return { '--core-spinner-color': `var(--${props.colorCssVar})` }
})

</script>

<template>
  <div
    data-test="core-loading"
    class="spinner tw-rounded-full"
    :class="[sizeClass]"
    :style="colorStyle" />
</template>

<style scoped>

.spinner {
  --small-size: 4px;
  --default-size: 6px;
   animation: spin 1s infinite linear;
}

.spinner-small-size {
  background: radial-gradient(farthest-side, var(--core-spinner-color) 94%,#0000) top/var(--small-size) var(--small-size) no-repeat,
          conic-gradient(#0000 30%, var(--core-spinner-color));
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - var(--small-size)),#000 0);
  mask: radial-gradient(farthest-side,#0000 calc(100% - var(--small-size)),#000 0);
}

.spinner-default-size {
  background: radial-gradient(farthest-side, var(--core-spinner-color) 94%,#0000) top/var(--default-size) var(--default-size) no-repeat,
          conic-gradient(#0000 30%, var(--core-spinner-color));
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - var(--default-size)),#000 0);
  mask: radial-gradient(farthest-side,#0000 calc(100% - var(--default-size)),#000 0);
}

@keyframes spin {
   100% {
      transform: rotate(1turn);
   }
}
</style>
